module.exports = __webpack_public_path__ + "static/media/3d-printer.edf7289f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sideMenu/icons/3d-printer.svg
// module id = 89
// module chunks = 0